<template>
    <v-container fluid>
        <v-layout row wrap>
            <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
                <h3 class="font-weight-bold">Trekking Requests</h3>
                <div class="text-xs-right"
                     v-if="trekking_agency && trekking_agency.status===1">
                    <v-btn @click="createFunction"
                           color="blue darken-3"
                           dark
                           fab
                           x-small>
                        <v-icon>add</v-icon>
                    </v-btn>
                    <export-button
                        class="ml-2"/>
                </div>
            </v-flex>
            <v-flex>
                <v-alert
                    text
                    dense
                    color="info"
                    icon="mdi-information-outline"
                    border="left"
                    class="subtitle-2"
                >
                    For Trekking Request Verification & Voucher generation, Please Contact Following Number. <br>
                    <span class="">Bishnu paudel (Computer Operator) <b>9841638083</b>, </span>
                    <span class="">Sanjaya Shrestha (Computer Operator) <b>9844050880</b>, </span>
                    <span class="">Sabina Gautam (Computer Operator) <b>9841184297</b>, </span>
                    <span class="pl-2">Uden Subedi (Computer Operator) <b>9842681298</b>, </span>
                </v-alert>
            </v-flex>
            <v-flex xs12>
                <v-card>
                    <v-layout class="py-1 mx-2" row wrap>
                        <v-flex class="pb-0" xs4>
                            <v-text-field
                                :elevation="0"
                                class="hidden-sm-and-down "
                                flat
                                hide-details
                                placeholder="Search by typing here..."
                                prepend-inner-icon="search"
                                solo
                                v-model="searchQuery"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                        <v-data-table
                            :footer-props="footerProps"
                            :headers="headers"
                            :items="trekking_requests"
                            :loading="loading"
                            :options.sync="pagination"
                            :server-items-length="totalNumber"
                            item-key="id"
                        >
                            <template v-slot:item.submission_no="{ item }">
                                <td>
                                    <span>{{ 'T' + item.id }}</span>
                                </td>
                            </template>
                            <template v-slot:item.status="{ item }">
                                <td>
                                    <v-chip color="green darken-1" text-color="white" v-if="item.status==='Approved'">
                                        Approved
                                    </v-chip>
                                    <v-chip color="green" text-color="white" v-else-if="item.status==='Paid'">Paid
                                    </v-chip>
                                    <v-chip color="primary darken-1" text-color="white"
                                            v-else-if="item.status==='Verified'">Verified
                                    </v-chip>
                                    <v-chip color="primary" text-color="white" v-else-if="item.status==='Applied'">
                                        Applied
                                    </v-chip>
                                    <v-chip color="red" text-color="white" v-else>{{ item.status }}</v-chip>
                                </td>
                            </template>
                            <template v-slot:item.action="{ item }"
                                      v-if="trekking_agency && trekking_agency.status===1">
                                <v-tooltip top v-if="item.status === 'Applied'">
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            @click="edit(item)"
                                            color="primary darken-1"
                                            dark
                                            dense
                                            fab
                                            v-on="on"
                                            x-small
                                        >
                                            <v-icon small>edit</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Edit</span>
                                </v-tooltip>

                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            @click="view(item)"
                                            class="ml-2"
                                            color="primary"
                                            dark
                                            dense
                                            fab
                                            v-on="on"
                                            x-small
                                        >
                                            <v-icon small>mdi-eye</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>View</span>
                                </v-tooltip>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import {mapGetters} from "vuex";

import {validationMixin} from "../../mixins/validationMixin";
import {CommonListMixin} from "../../mixins/CommonListMixin";
import ExportButton from "../../components/ExportButton";

export default {
    name: "list",
    components: {ExportButton},
    data() {
        return {
            model: "trekkings",
            // loading: false,
            headers: [
                {
                    text: 'S.N.',
                    value: 's_no',
                    sortable: false
                },
                {
                    text: 'Submission No',
                    value: 'submission_no',
                    sortable: false
                },
                {
                    text: "Trekking Route",
                    value: "name"
                },
                {
                    text: "Total Cost",
                    value: "total_cost"
                },
                {
                    text: "Starting Date",
                    value: "starting_date"
                },
                {
                    text: "Status",
                    value: "status"
                },
                {
                    text: "No. of Trekkers",
                    value: "no_of_trekkers"
                },
                {
                    text: "Created Date",
                    value: "created_at"
                },
                {
                    text: "Action",
                    value: "action",
                    sortable: false
                }
            ]
        }
    },
    computed: {
        ...mapGetters("AuthUser", ["trekking_agency"]),
        trekking_requests() {
            return this.$store.state.CommonList.all;
        },
    },
    mixins: [validationMixin, CommonListMixin],
    methods: {
        createFunction() {
            this.$store.commit('TrekkingSingle/resetTrekkingData');
            this.$router.push({
                name: "TrekkingRequestNew"
            })
        },
        view(item) {
            this.$router.push({
                name: "ViewTrekkingRequest",
                params: {id: item.id}
            });
        },
        edit(item) {
            this.$router.push({
                name: "EditTrekkingRequest",
                params: {id: item.id}
            });
        }
    },
    mounted() {
        this.$store.commit("CommonList/setModel", this.model);
    }
}
</script>

<style scoped>

</style>
